import React, { useMemo } from 'react';
import Charts from 'echarts-for-react';
import styles from '../styles.less';
import { CHART_COLORS, TYPE_LABEL } from '../staticData';

/** 每周 · 内容生成趋势（文案 / 图片 / 视频 堆叠柱状图） */
const UsageTrendChart = ({ list }) => {
  const option = useMemo(() => {
    const source = list || [];
    const pick = (key) => source.map((item) => item.data?.[key] || 0);
    const series = ['text', 'image', 'video'].map((type) => ({
      name: TYPE_LABEL[type],
      type: 'bar',
      stack: 'content',
      barWidth: 36,
      itemStyle: { color: CHART_COLORS[type] },
      data: pick(type),
    }));
    return {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      legend: {
        bottom: 0,
        icon: 'rect',
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 20,
        textStyle: { color: '#6b7280', fontSize: 12 },
      },
      grid: { left: 0, right: 12, top: 20, bottom: 34, containLabel: true },
      xAxis: {
        type: 'category',
        data: source.map((item) => item.week),
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#e8ecf1' } },
        axisLabel: { color: '#6b7280', fontSize: 12 },
      },
      yAxis: {
        type: 'value',
        min: 0,
        splitNumber: 6,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: '#eef1f5', type: 'dashed' } },
        axisLabel: { color: '#9ca3af', fontSize: 12 },
      },
      series,
    };
  }, [list]);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>
          <svg
            className={styles.cardTitleIcon}
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <rect x="1" y="8" width="3" height="7" rx="1" fill="#64748b" />
            <rect x="6.5" y="4" width="3" height="11" rx="1" fill="#94a3b8" />
            <rect x="12" y="1" width="3" height="14" rx="1" fill="#475569" />
          </svg>
          每周 · 内容生成趋势
        </span>
      </div>
      <Charts notMerge option={option} style={{ height: 260 }} />
    </div>
  );
};

export default UsageTrendChart;
